import React from "react";
import { Check, Minus } from "lucide-react";
import Icon from "../icon/Icon";

type CheckboxProps = {
    checked?: boolean;
    indeterminate?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
    "aria-label"?: string;
};

const Checkbox = ({
    checked = false,
    indeterminate = false,
    onChange,
    disabled = false,
    className = "",
    "aria-label": ariaLabel,
}: CheckboxProps) => {
    const handleClick = () => {
        if (disabled) return;
        onChange?.(!checked);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            role="checkbox"
            aria-checked={indeterminate ? "mixed" : checked}
            aria-label={ariaLabel}
            tabIndex={disabled ? -1 : 0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={`
                inline-flex items-center justify-center
                w-5 h-5
                rounded-xs
                border-2
                transition-all duration-200
                cursor-pointer
                ${checked || indeterminate
                    ? "bg-primary border-primary"
                    : "bg-white border-border hover:border-primary"
                }
                ${disabled ? "opacity-50 cursor-not-allowed" : ""}
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2
                ${className}
            `}
        >
            {indeterminate ? (
                <Icon icon={Minus} size={14} className="text-white" />
            ) : checked ? (
                <Icon icon={Check} size={14} className="text-white" />
            ) : null}
        </div>
    );
};

export default Checkbox;

